<template>
    <div class="view view-challenge-practice">
        <ChallengeUserboard
            @enableLoading="enableLoading"
            @disableLoading="disableLoading" />
        <template v-if="showQuestionPhonemicVowel">
            <QuestionObjectPhonemicVowel
                :phonemicValue="this.curQuestion.questionObject.valuePhonemic" />
            <p class="view-challenge-practice__question-desc-phonemic-vowel">Üç boyutluluk özelliklerini işaretle.</p>
            <div class="wr-view-challenge-practice__optionboard-phonemic-vowel">
                <ScoreboardPhonemicVowel
                    :scorelist="scorelist" />
                <OptionboardPhonemicVowel
                    :backnessOptions="backnessOptions"
                    :heightOptions="heightOptions"
                    :roundednessOptions="roundednessOptions" />
            </div>
        </template>

        <template v-if="showFeedbackPhonemicVowel">
            <QuestionObjectPhonemicVowel
                :phonemicValue="this.curQuestion.questionObject.valuePhonemic" />
            <p class="view-challenge-practice__question-desc-phonemic-vowel">Üç boyutluluk özelliklerini işaretle.</p>
            <div class="wr-view-challenge-practice__optionboard-phonemic-vowel">
                <ScoreboardPhonemicVowel
                    :scorelist="scorelist" />
                <FeedbackboardPhonemicVowel />
            </div>
        </template>

        <template v-if="showQuestionPhonemicConsonant">
            <QuestionObjectPhonemicConsonant
                :phonemicValue="this.curQuestion.questionObject.valuePhonemic" />
            <p class="view-challenge-practice__question-desc-phonemic-consonant">Üç boyutluluk özelliklerini işaretle.</p>
            <div class="wr-view-challenge-practice__optionboard-phonemic-consonant">
                <ScoreboardPhonemicConsonant
                    :scorelist="scorelist" />
                <OptionboardPhonemicConsonant
                    :placeOptions="placeOptions"
                    :mannerOptions="mannerOptions" />
            </div>
        </template>

        <template v-if="showFeedbackPhonemicConsonant">
            <QuestionObjectPhonemicConsonant
                :phonemicValue="this.curQuestion.questionObject.valuePhonemic" />
            <p class="view-challenge-practice__question-desc-phonemic-consonant">Üç boyutluluk özelliklerini işaretle.</p>
            <div class="wr-view-challenge-practice__optionboard-phonemic-consonant">
                <ScoreboardPhonemicConsonant
                    :scorelist="scorelist" />
                <FeedbackboardPhonemicConsonant />
            </div>
        </template>

        <template v-if="showQuestionPhoneticVowel">
            <QuestionObjectPhoneticVowel
                :phonemicValue="this.curQuestion.questionObject.valuePhonemic"
                :phoneticValue="this.curQuestion.questionObject.valuePhonetic" />
            <p class="view-challenge-practice__question-desc-phonetic-vowel">Değişke özelliğini işaretle.</p>
            <div class="wr-view-challenge-practice__optionboard-phonetic-vowel">
                <ScoreboardPhoneticVowel
                    :scorelist="scorelist" />
                <OptionboardPhoneticVowel
                    :variantOptions="variantOptions" />
            </div>
        </template>

        <template v-if="showFeedbackPhoneticVowel">
            <QuestionObjectPhoneticVowel
                :phonemicValue="this.curQuestion.questionObject.valuePhonemic"
                :phoneticValue="this.curQuestion.questionObject.valuePhonetic" />
            <p class="view-challenge-practice__question-desc-phonetic-vowel">Değişke özelliğini işaretle.</p>
            <div class="wr-view-challenge-practice__optionboard-phonetic-vowel">
                <ScoreboardPhoneticVowel
                    :scorelist="scorelist" />
                <FeedbackboardPhoneticVowel />
            </div>
        </template>

        <template v-if="showQuestionPhoneticConsonant">
            <QuestionObjectPhoneticConsonant
                :phonemicValue="this.curQuestion.questionObject.valuePhonemic"
                :phoneticValue="this.curQuestion.questionObject.valuePhonetic" />
            <p class="view-challenge-practice__question-desc-phonetic-consonant">Değişke özelliğini işaretle.</p>
            <div class="wr-view-challenge-practice__optionboard-phonetic-consonant">
                <ScoreboardPhoneticConsonant
                    :scorelist="scorelist" />
                <OptionboardPhoneticConsonant
                    :consonantVariantOptions="variantOptions" />
            </div>
        </template>

        <template v-if="showFeedbackPhoneticConsonant">
            <QuestionObjectPhoneticConsonant
                :phonemicValue="this.curQuestion.questionObject.valuePhonemic"
                :phoneticValue="this.curQuestion.questionObject.valuePhonetic" />
            <p class="view-challenge-practice__question-desc-phonetic-consonant">Değişke özelliğini işaretle.</p>
            <div class="wr-view-challenge-practice__optionboard-phonetic-consonant">
                <ScoreboardPhoneticConsonant
                    :scorelist="scorelist" />
                <FeedbackboardPhoneticConsonant />
            </div>
        </template>

        <BtnAnswerCheck
            v-if="!feedbackPhase"
            @click="this.$store.state.envDev ? checkAnswer() : checkAnswerApi()" />
        <BtnAnswerSkip
            v-if="!feedbackPhase"
            @click="this.$store.state.envDev ? skipAnswer() : skipAnswerApi()" />

        <BtnQuestionNext
            v-if="feedbackPhase"
            :correctness="correctness"
            @click="this.$store.state.envDev ? nextQuestion() : nextQuestionApi()" />
        <Feedbackbar
            v-if="feedbackPhase"
            :correctness="correctness" />

        <LoadingChallengePractice
            v-if="showLoading" />
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    import ChallengeUserboard               from '@/components/ChallengeUserboard.vue';

    import QuestionObjectPhonemicVowel      from '@/components/QuestionObjectPhonemicVowel.vue';
    import OptionboardPhonemicVowel         from '@/components/OptionboardPhonemicVowel.vue';
    import ScoreboardPhonemicVowel          from '@/components/ScoreboardPhonemicVowel.vue';
    import FeedbackboardPhonemicVowel       from '@/components/FeedbackboardPhonemicVowel.vue';

    import QuestionObjectPhonemicConsonant  from '@/components/QuestionObjectPhonemicConsonant.vue';
    import ScoreboardPhonemicConsonant      from '@/components/ScoreboardPhonemicConsonant.vue';
    import OptionboardPhonemicConsonant     from '@/components/OptionboardPhonemicConsonant.vue';
    import FeedbackboardPhonemicConsonant   from '@/components/FeedbackboardPhonemicConsonant.vue';
    
    import QuestionObjectPhoneticVowel      from '@/components/QuestionObjectPhoneticVowel.vue';
    import ScoreboardPhoneticVowel          from '@/components/ScoreboardPhoneticVowel.vue';
    import OptionboardPhoneticVowel         from '@/components/OptionboardPhoneticVowel.vue';
    import FeedbackboardPhoneticVowel       from '@/components/FeedbackboardPhoneticVowel.vue';

    import QuestionObjectPhoneticConsonant  from '@/components/QuestionObjectPhoneticConsonant.vue';
    import ScoreboardPhoneticConsonant      from '@/components/ScoreboardPhoneticConsonant.vue';
    import OptionboardPhoneticConsonant     from '@/components/OptionboardPhoneticConsonant.vue';
    import FeedbackboardPhoneticConsonant   from '@/components/FeedbackboardPhoneticConsonant.vue';

    import BtnAnswerCheck                   from '@/components/BtnAnswerCheck.vue';
    import BtnAnswerSkip                    from '@/components/BtnAnswerSkip.vue';
    import BtnQuestionNext                  from '@/components/BtnQuestionNext.vue';
    import Feedbackbar                      from '@/components/Feedbackbar.vue';

    import LoadingChallengePractice         from '@/components/LoadingChallengePractice.vue';




    /*
        +---+---+---+--+---+--+---+---+---+---+---+

                Library Imports

        +---+---+---+--+---+--+---+---+---+---+---+
    */
    import OptionGenerator      from '@/libs/OptionGenerator.js';


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        components: {
            ChallengeUserboard,

            QuestionObjectPhonemicVowel,
            ScoreboardPhonemicVowel,
            OptionboardPhonemicVowel,
            FeedbackboardPhonemicVowel,

            QuestionObjectPhonemicConsonant,
            ScoreboardPhonemicConsonant,
            OptionboardPhonemicConsonant,
            FeedbackboardPhonemicConsonant,

            QuestionObjectPhoneticVowel,
            ScoreboardPhoneticVowel,
            OptionboardPhoneticVowel,
            FeedbackboardPhoneticVowel,

            QuestionObjectPhoneticConsonant,
            ScoreboardPhoneticConsonant,
            OptionboardPhoneticConsonant,
            FeedbackboardPhoneticConsonant,

            BtnAnswerCheck,
            BtnAnswerSkip,
            BtnQuestionNext,
            Feedbackbar,

            LoadingChallengePractice,
        },

        data(){
            return {
                showLoading: false,
                allowRequest: true,
                feedbackPhase: false,
                scorelist: [-1, -1, -1],
                correctness: null,
                backnessOptions:    [],
                heightOptions:      [],
                roundednessOptions: [],
                placeOptions:   [],
                mannerOptions:  [],
                variantOptions: [],
            };
        },

        computed: {
            showQuestionPhonemicVowel(){
                if(this.curQuestion.type === 'phonemic-vowel' && this.feedbackPhase === false){
                    return true;
                }
                return false;
            },

            showFeedbackPhonemicVowel(){
                if(this.curQuestion.type === 'phonemic-vowel' && this.feedbackPhase === true){
                    return true;
                }
                return false;
            },

            showQuestionPhonemicConsonant(){
                if(this.curQuestion.type === 'phonemic-consonant' && this.feedbackPhase === false){
                    return true;
                }
                return false;
            },

            showFeedbackPhonemicConsonant(){
                if(this.curQuestion.type === 'phonemic-consonant' && this.feedbackPhase === true){
                    return true;
                }
                return false;
            },

            showQuestionPhoneticVowel(){
                if(this.curQuestion.type === 'phonetic-vowel' && this.feedbackPhase === false){
                    return true;
                }
                return false;
            },

            showFeedbackPhoneticVowel(){
                if(this.curQuestion.type === 'phonetic-vowel' && this.feedbackPhase === true){
                    return true;
                }
                return false;
            },

            showQuestionPhoneticConsonant(){
                if(this.curQuestion.type === 'phonetic-consonant' && this.feedbackPhase === false){
                    return true;
                }
                return false;
            },

            showFeedbackPhoneticConsonant(){
                if(this.curQuestion.type === 'phonetic-consonant' && this.feedbackPhase === true){
                    return true;
                }
                return false;
            },

            curQuestion(){
                let idxCurQuestion = this.$store.state.challengePracticeSession.idxCurQuestion
                let questionSet    = this.$store.state.challengeQuestionSet;
                return questionSet[idxCurQuestion];
            },

            nxtQuestion(){
                let idxCurQuestion = this.$store.state.challengePracticeSession.idxCurQuestion + 1;
                let questionSet    = this.$store.state.challengeQuestionSet;
                return questionSet[idxCurQuestion];
            },

            featureGroupName(){
                if(this.curQuestion.type === 'phonemic-vowel'){
                    return 'vowelFeatures';
                }
                else if(this.curQuestion.type === 'phonemic-consonant'){
                    return 'consonantFeatures';
                }
                else if(this.curQuestion.type === 'phonetic-vowel'){
                    return 'vowelFeatures';
                }
                else if(this.curQuestion.type === 'phonetic-consonant'){
                    return 'consonantFeatures';
                }
            },

            vocalizationSlug(){
                let idxCurQUestion = this.$store.state.challengePracticeSession.idxCurQuestion;
                let questionSet = this.$store.state.challengeQuestionSet;
                
                if(this.curQuestion.type === 'phonemic-vowel'){
                    return 'phonemicVowel' + this.curQuestion.questionObject.valuePhonemic;
                }
                else if(this.curQuestion.type === 'phonemic-consonant'){
                    return 'phonemicConsonant' + this.curQuestion.questionObject.valuePhonemic.toUpperCase();
                }
                else if(this.curQuestion.type === 'phonetic-vowel'){
                    let variantFeature = this.curQuestion.vowelFeatures.variant.replace('-', '');
                    return 'phoneticVowel' + this.curQuestion.questionObject.valuePhonemic + variantFeature[0].toUpperCase() + variantFeature.slice(1);
                }
                else if(this.curQuestion.type === 'phonetic-consonant'){
                    let variantFeature = this.curQuestion.consonantFeatures.variant.replaceAll('-', '');
                    return 'phoneticConsonant' + this.curQuestion.questionObject.valuePhonemic.toUpperCase() + variantFeature;
                }
            },
        },

        methods: {
            getAnswerDataSchema(type){
                if(type === 'phonemic-vowel'){
                    return {
                        vowelFeatures: {
                            backness:    null,
                            height:      null,
                            roundedness: null,
                        }
                    };
                }
                else if(type === 'phonemic-consonant'){
                    return {
                        consonantFeatures: {
                            place:   null,
                            manner:  null,
                            voicing: null,
                        }
                    };
                }
                else if(type === 'phonetic-vowel'){
                    return {
                        vowelFeatures: {
                            variant:   null,
                        }
                    };
                }
                else if(type === 'phonetic-consonant'){
                    return {
                        consonantFeatures: {
                            variant: null,
                        }
                    }
                }
            },
            
            getFeedbackDataSchema(type){
                if(type === 'phonemic-vowel'){
                    return {
                        backness: {
                            correctValue: null,
                            answerValue:  null,
                        },
                        height: {
                            correctValue: null,
                            answerValue:  null,
                        },
                        roundedness: {
                            correctValue: null,
                            answerValue:  null,
                        }
                    };
                }
                else if(type === 'phonemic-consonant'){
                    return {
                        place: {
                            correctValue: null,
                            answerValue:  null,
                        },
                        manner: {
                            correctValue: null,
                            answerValue:  null,
                        },
                        voicing: {
                            correctValue: null,
                            answerValue:  null,
                        }
                    };
                }
                else if(type === 'phonetic-vowel'){
                    return {
                        variant: {
                            correctValue: null,
                            answerValue:  null,
                        }
                    };
                }
                else if(type === 'phonetic-consonant'){
                    return {
                        variant: {
                            correctValue: null,
                            answerValue:  null,
                        }
                    };
                }
            },

            getInitialScorelist(type){
                if(type === 'phonemic-vowel'){
                    return [-1, -1, -1];
                }
                else if(type === 'phonemic-consonant'){
                    return [-1, -1, -1];
                }
                else if(type === 'phonetic-vowel'){
                    return [-1];
                }
                else if(type === 'phonetic-consonant'){
                    return [-1]
                }
            },

            camelize(s){
                return s.replace(/-./g, match => match[1].toUpperCase());
            },

            vocalize(){
                this.$store.state.sfx[this.vocalizationSlug].currentTime = 0;
                this.$store.state.sfx[this.vocalizationSlug].play();
            },

            checkAnswer(){
                // Prevent answer checks if user hasn't chosen an option for each feature type.
                for(const [feature, answerValue] of Object.entries(this.$store.state.answerData[this.featureGroupName])){
                    if(!answerValue){
                        this.$foneturkToast(this.$t(`alert.answerCheckPrevention.${this.camelize(this.curQuestion.type)}`), 'DİKKAT');
                        return false;
                    }
                }

                // Compare correct feature-value against answer feature-value.
                let scorelist    = [];
                let correctness  = 1;
                let feedbackData = this.getFeedbackDataSchema(this.curQuestion.type);

                for(const [feature, correctValue] of Object.entries(this.curQuestion[this.featureGroupName])){
                    let featureCorrectness = 1;
                    let answerValue = this.$store.state.answerData[this.featureGroupName][feature];
                    if(correctValue !== answerValue){
                        correctness        = 0;
                        featureCorrectness = 0;
                    }
                    scorelist.push(featureCorrectness);
                    feedbackData[feature].correctValue = correctValue;
                    feedbackData[feature].answerValue = answerValue;
                }

                this.scorelist   = scorelist;
                this.correctness = correctness;
                this.$store.commit('setFeedbackData', feedbackData);
                if(this.correctness === 1){
                    this.$store.commit('incrementChallengeStatCorrect');
                }
                else if(this.correctness === 0){
                    this.$store.commit('incrementChallengeStatIncorrect');
                }
                this.feedbackPhase = true;

                // Play SFX based on correctness.
                if(this.correctness === 1){
                    this.$store.state.sfx.correct.currentTime = 0;
                    this.$store.state.sfx.correct.play();
                }
                else if(this.correctness === 0){
                    this.$store.state.sfx.incorrect.currentTime = 0;
                    this.$store.state.sfx.incorrect.play();
                }
            },

            checkAnswerApi(){
                // Prevent answer checks if user hasn't chosen an option for each feature type.
                for(const [feature, answerValue] of Object.entries(this.$store.state.answerData[this.featureGroupName])){
                    if(!answerValue){
                        this.$foneturkToast(this.$t(`alert.answerCheckPrevention.${this.camelize(this.curQuestion.type)}`), 'DİKKAT');
                        return false;
                    }
                }
                
                // Prevent multiple requests.
                if(this.allowRequest === false){
                    return false;
                }
                this.allowRequest = false;

                // Send request.
                fetch(this.$store.state.api.challengeCheckAnswer, {
                    method: 'POST',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    body: `answerData=${JSON.stringify(this.$store.state.answerData)}`
                })
                .then(async response => {
                    if(response.status !== 200){
                        throw await response.json();
                    }
                    return response.json();
                })
                .then(correctnessData => {
                    this.scorelist   = correctnessData.scorelist;
                    this.correctness = correctnessData.correctness;
                    this.$store.commit('setFeedbackData', correctnessData.feedbackData);
                    if(this.correctness === 1){
                        this.$store.commit('incrementChallengeStatCorrect');
                    }
                    else if(this.correctness === 0){
                        this.$store.commit('incrementChallengeStatIncorrect');
                    }
                    this.feedbackPhase = true;

                    // Play SFX based on correctness.
                    if(this.correctness === 1){
                        this.$store.state.sfx.correct.currentTime = 0;
                        this.$store.state.sfx.correct.play();
                    }
                    else if(this.correctness === 0){
                        this.$store.state.sfx.incorrect.currentTime = 0;
                        this.$store.state.sfx.incorrect.play();
                    }

                    this.allowRequest = true;
                })
                .catch(err => {
                    if(err.code === 'CHALLENGE_CHECK_ANSWER_CONTROLLER/INDEX::INV_USER_SESSION'){
                        this.$foneturkError({
                            text: this.$t(`error.api.challengeCheckAnswer.${err.code}`),
                            didClose: () => {
                                // this.$router.push('/login');
                            }
                        });
                    }
                    else{
                        this.$foneturkError({
                            text: this.$t(`error.default`),
                            didClose: () => {
                                // this.$router.push('/');
                            }
                        });
                    }
                });
            },

            skipAnswer(){
                let scorelist = this.getInitialScorelist(this.curQuestion.type)
                let feedbackData = this.getFeedbackDataSchema(this.curQuestion.type);

                for(const [feature, correctValue] of Object.entries(this.curQuestion[this.featureGroupName])){
                    feedbackData[feature].correctValue = correctValue;
                    feedbackData[feature].answerValue = '';
                }
                
                this.scorelist = scorelist;
                this.correctness = -1;
                this.$store.commit('setFeedbackData', feedbackData);
                this.$store.commit('incrementChallengeStatSkipped');
                this.feedbackPhase = true;

                // Play SFX.
                this.$store.state.sfx.skipped.currentTime = 0;
                this.$store.state.sfx.skipped.play();
            },

            skipAnswerApi(){
                // Prevent multiple requests.
                if(this.allowRequest === false){
                    return false;
                }
                this.allowRequest = false;

                // Send request.
                fetch(this.$store.state.api.challengeSkipAnswer, {
                    method: 'POST',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                })
                .then(async response => {
                    if(response.status !== 200){
                        throw await response.json();
                    }
                    return response.json();
                })
                .then(correctnessData => {
                    this.scorelist   = correctnessData.scorelist;
                    this.correctness = correctnessData.correctness;
                    this.$store.commit('setFeedbackData', correctnessData.feedbackData);
                    this.$store.commit('incrementChallengeStatSkipped');
                    this.feedbackPhase = true;

                    // Play SFX.
                    this.$store.state.sfx.skipped.currentTime = 0;
                    this.$store.state.sfx.skipped.play();

                    this.allowRequest = true;
                })
                .catch(err => {
                    if(err.code === 'CHALLENGE_SKIP_ANSWER_CONTROLLER/INDEX::INV_USER_SESSION'){
                        this.$foneturkError({
                            text: this.$t(`error.api.challengeSkipAnswer.${err.code}`),
                            didClose: () => {
                                // this.$router.push('/login');
                            }
                        });
                    }
                    else{
                        this.$foneturkError({
                            text: this.$t(`error.default`),
                            didClose: () => {
                                // this.$router.push('/challenge');
                            }
                        });
                    }
                });
            },

            nextQuestion(){
                // Check if practice has ended.
                if(!this.nxtQuestion){
                    alert('Practice has ended.');
                    return true;
                }

                // Reset dprops and vuex states.
                this.scorelist   = this.getInitialScorelist(this.nxtQuestion.type);
                this.correctness = null;
                this.$store.commit('setFeedbackData', null);
                this.$store.commit('setAnswerDataSchema', this.getAnswerDataSchema(this.nxtQuestion.type));

                // Genereate option for the next question.
                let optionGenerator = new OptionGenerator();
                if(this.nxtQuestion.type === 'phonemic-vowel'){
                    this.backnessOptions    = optionGenerator.generateVowelBacknessOptions();
                    this.heightOptions      = optionGenerator.generateVowelHeightOptions();
                    this.roundednessOptions = optionGenerator.generateVowelRoundednessOptions();
                }
                else if(this.nxtQuestion.type === 'phonemic-consonant'){
                    this.placeOptions   = optionGenerator.generatePlaceOptions(this.nxtQuestion.consonantFeatures.place);
                    this.mannerOptions  = optionGenerator.generateMannerOptions(this.nxtQuestion.consonantFeatures.manner);
                }
                else if(this.nxtQuestion.type === 'phonetic-vowel'){
                    this.variantOptions = optionGenerator.generateVowelVariantOptions(this.nxtQuestion.vowelFeatures.variant);
                }
                else if(this.nxtQuestion.type === 'phonetic-consonant'){
                    this.variantOptions = optionGenerator.generateConsonantVariantOptions(this.nxtQuestion.consonantFeatures.variant);
                }
                
                this.feedbackPhase = false;
                this.$store.commit('setChallengeNextQuestion');

                this.$nextTick(() => {
                    // Play animations.
                    document.querySelector(`.question-object-${this.curQuestion.type}`).classList.add('slide-in');
                    setTimeout(() => {
                        // @reason: I wrapped classlist removal in try catch because when a user quickly
                        // does skip-check and completes practice session, DOM can't find the question
                        // object element which causes a type error that it cannot read classList prop of null.
                        try{ document.querySelector(`.question-object-${this.curQuestion.type}`).classList.remove('slide-in'); }
                        catch(error){ return; }
                    }, 500);
                });

                // Play next question vocalization after 500ms.
                setTimeout(() => this.vocalize(), 500);
            },

            nextQuestionApi(){
                // Prevent multiple requests.
                if(this.allowRequest === false){
                    return false;
                }
                this.allowRequest = false;

                // Send request.
                fetch(this.$store.state.api.challengeNextQuestion, {
                    method: 'POST',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                })
                .then(async response => {
                    if(response.status !== 200){
                        throw await response.json();
                    }
                    return response.json();
                })
                .then(nextQuestionData => {
                    if(nextQuestionData.completion === true){
                        this.$router.push('/challenge/results');
                        return true;
                    }

                    // Reset dprops and vuex states.
                    this.scorelist   = this.getInitialScorelist(this.nxtQuestion.type);
                    this.correctness = null;
                    this.$store.commit('setFeedbackData', null);
                    this.$store.commit('setAnswerDataSchema', this.getAnswerDataSchema(this.nxtQuestion.type));

                    // Genereate option for the next question.
                    let optionGenerator = new OptionGenerator();
                    if(this.nxtQuestion.type === 'phonemic-vowel'){
                        this.backnessOptions    = optionGenerator.generateVowelBacknessOptions();
                        this.heightOptions      = optionGenerator.generateVowelHeightOptions();
                        this.roundednessOptions = optionGenerator.generateVowelRoundednessOptions();
                    }
                    else if(this.nxtQuestion.type === 'phonemic-consonant'){
                        this.placeOptions   = optionGenerator.generatePlaceOptions(this.nxtQuestion.consonantFeatures.place);
                        this.mannerOptions  = optionGenerator.generateMannerOptions(this.nxtQuestion.consonantFeatures.manner);
                    }
                    else if(this.nxtQuestion.type === 'phonetic-vowel'){
                        this.variantOptions = optionGenerator.generateVowelVariantOptions(this.nxtQuestion.vowelFeatures.variant);
                    }
                    else if(this.nxtQuestion.type === 'phonetic-consonant'){
                        this.variantOptions = optionGenerator.generateConsonantVariantOptions(this.nxtQuestion.consonantFeatures.variant);
                    }
                    
                    this.feedbackPhase = false;
                    this.$store.commit('setChallengeNextQuestion');

                    this.$nextTick(() => {
                        // Play animations.
                        document.querySelector(`.question-object-${this.curQuestion.type}`).classList.add('slide-in');
                        setTimeout(() => {
                            // @reason: I wrapped classlist removal in try catch because when a user quickly
                            // does skip-check and completes practice session, DOM can't find the question
                            // object element which causes a type error that it cannot read classList prop of null.
                            try{ document.querySelector(`.question-object-${this.curQuestion.type}`).classList.remove('slide-in'); }
                            catch(error){ return; }
                        }, 500);
                    });

                    // Play next question vocalization after 500ms.
                    setTimeout(() => this.vocalize(), 500);

                    // Allow request.
                    this.allowRequest = true;
                })
                .catch(err => {
                    if(err.code === 'CHALLENGE_NEXT_QUESTION_MODEL/NEXT::INV_USER_SESSION'){
                        this.$foneturkError({
                            text: this.$t(`error.api.challengeNextQuestion.${err.code}`),
                            didClose: () => {
                                // this.$router.push('/login');
                            }
                        });
                    }
                    else{
                        this.$foneturkError({
                            text: this.$t(`error.default`),
                            didClose: () => {
                                this.$router.push('/challenge');
                            }
                        });
                    }
                });
            },

            enableLoading(){
                this.showLoading = true;
            },

            disableLoading(){
                this.showLoading = false;
            }
        },

        beforeMount(){
            // Used for testing all questions of a question type.
            // this.$store.commit('setChallengeQuestionSet', [{type:"phonemic-vowel",questionObject:{id:1,valuePhonemic:"a"},vowelFeatures:{backness:"back",height:"open",roundedness:"unrounded"}},{type:"phonemic-vowel",questionObject:{id:2,valuePhonemic:"e"},vowelFeatures:{backness:"front",height:"open",roundedness:"unrounded"}},{type:"phonemic-vowel",questionObject:{id:3,valuePhonemic:"o"},vowelFeatures:{backness:"back",height:"open",roundedness:"rounded"}},{type:"phonemic-vowel",questionObject:{id:4,valuePhonemic:"ö"},vowelFeatures:{backness:"front",height:"open",roundedness:"rounded"}},{type:"phonemic-vowel",questionObject:{id:5,valuePhonemic:"ı"},vowelFeatures:{backness:"central",height:"close",roundedness:"unrounded"}},{type:"phonemic-vowel",questionObject:{id:6,valuePhonemic:"i"},vowelFeatures:{backness:"front",height:"close",roundedness:"unrounded"}},{type:"phonemic-vowel",questionObject:{id:7,valuePhonemic:"u"},vowelFeatures:{backness:"back",height:"close",roundedness:"rounded"}},{type:"phonemic-vowel",questionObject:{id:8,valuePhonemic:"ü"},vowelFeatures:{backness:"front",height:"close",roundedness:"rounded"}}]);
            // this.$store.commit('setChallengeQuestionSet', [{type:"phonemic-consonant",questionObject:{id:1,valuePhonemic:"p"},consonantFeatures:{manner:"plosive",place:"bilabial",voicing:"voiceless"}},{type:"phonemic-consonant",questionObject:{id:2,valuePhonemic:"b"},consonantFeatures:{manner:"plosive",place:"bilabial",voicing:"voiced"}},{type:"phonemic-consonant",questionObject:{id:3,valuePhonemic:"t"},consonantFeatures:{manner:"plosive",place:"alveolar",voicing:"voiceless"}},{type:"phonemic-consonant",questionObject:{id:4,valuePhonemic:"d"},consonantFeatures:{manner:"plosive",place:"alveolar",voicing:"voiced"}},{type:"phonemic-consonant",questionObject:{id:5,valuePhonemic:"k"},consonantFeatures:{manner:"plosive",place:"velar",voicing:"voiceless"}},{type:"phonemic-consonant",questionObject:{id:6,valuePhonemic:"g"},consonantFeatures:{manner:"plosive",place:"velar",voicing:"voiced"}},{type:"phonemic-consonant",questionObject:{id:7,valuePhonemic:"f"},consonantFeatures:{manner:"fricative",place:"labiodental",voicing:"voiceless"}},{type:"phonemic-consonant",questionObject:{id:8,valuePhonemic:"v"},consonantFeatures:{manner:"fricative",place:"labiodental",voicing:"voiced"}},{type:"phonemic-consonant",questionObject:{id:9,valuePhonemic:"s"},consonantFeatures:{manner:"fricative",place:"alveolar",voicing:"voiceless"}},{type:"phonemic-consonant",questionObject:{id:10,valuePhonemic:"z"},consonantFeatures:{manner:"fricative",place:"alveolar",voicing:"voiced"}},{type:"phonemic-consonant",questionObject:{id:11,valuePhonemic:"ş"},consonantFeatures:{manner:"fricative",place:"postalveolar",voicing:"voiceless"}},{type:"phonemic-consonant",questionObject:{id:12,valuePhonemic:"j"},consonantFeatures:{manner:"fricative",place:"postalveolar",voicing:"voiced"}},{type:"phonemic-consonant",questionObject:{id:13,valuePhonemic:"h"},consonantFeatures:{manner:"fricative",place:"glottal",voicing:"voiceless"}},{type:"phonemic-consonant",questionObject:{id:14,valuePhonemic:"y"},consonantFeatures:{manner:"approximant",place:"palatal",voicing:"voiced"}},{type:"phonemic-consonant",questionObject:{id:15,valuePhonemic:"m"},consonantFeatures:{manner:"nasal",place:"bilabial",voicing:"voiced"}},{type:"phonemic-consonant",questionObject:{id:16,valuePhonemic:"n"},consonantFeatures:{manner:"nasal",place:"alveolar",voicing:"voiced"}},{type:"phonemic-consonant",questionObject:{id:17,valuePhonemic:"r"},consonantFeatures:{manner:"tap-or-flap",place:"alveolar",voicing:"voiced"}},{type:"phonemic-consonant",questionObject:{id:18,valuePhonemic:"l"},consonantFeatures:{manner:"lateral-approximant",place:"alveolar",voicing:"voiced"}},{type:"phonemic-consonant",questionObject:{id:19,valuePhonemic:"ç"},consonantFeatures:{manner:"affricate",place:"postalveolar",voicing:"voiceless"}},{type:"phonemic-consonant",questionObject:{id:20,valuePhonemic:"c"},consonantFeatures:{manner:"affricate",place:"postalveolar",voicing:"voiced"}}]);
            // this.$store.commit('setChallengeQuestionSet', [{type:"phonetic-vowel",questionObject:{id:1,valuePhonemic:"a",valuePhonetic:"ɑ",examplePhonemic:"kar",examplePhonetic:"kʰɑɣ"},vowelFeatures:{variant:"postdorsal"}},{type:"phonetic-vowel",questionObject:{id:2,valuePhonemic:"a",valuePhonetic:"a",examplePhonemic:"kâr",examplePhonetic:"cʰaɣ"},vowelFeatures:{variant:"predorsal"}},{type:"phonetic-vowel",questionObject:{id:3,valuePhonemic:"e",valuePhonetic:"e",examplePhonemic:"kedi",examplePhonetic:"cʰedɪ"},vowelFeatures:{variant:"close"}},{type:"phonetic-vowel",questionObject:{id:4,valuePhonemic:"e",valuePhonetic:"ɛ",examplePhonemic:"tek",examplePhonetic:"tʰɛc"},vowelFeatures:{variant:"open"}},{type:"phonetic-vowel",questionObject:{id:5,valuePhonemic:"e",valuePhonetic:"æ",examplePhonemic:"kelebek",examplePhonetic:"cʰelæbɛc"},vowelFeatures:{variant:"near-open"}},{type:"phonetic-vowel",questionObject:{id:6,valuePhonemic:"o",valuePhonetic:"o",examplePhonemic:"oğul",examplePhonetic:"o•uɫ"},vowelFeatures:{variant:"close"}},{type:"phonetic-vowel",questionObject:{id:7,valuePhonemic:"o",valuePhonetic:"ɔ",examplePhonemic:"çok",examplePhonetic:"tʃɔk"},vowelFeatures:{variant:"open"}},{type:"phonetic-vowel",questionObject:{id:8,valuePhonemic:"ö",valuePhonetic:"ø",examplePhonemic:"köy",examplePhonetic:"cʰø•ɪ"},vowelFeatures:{variant:"close"}},{type:"phonetic-vowel",questionObject:{id:9,valuePhonemic:"ö",valuePhonetic:"œ",examplePhonemic:"töz",examplePhonetic:"tʰœz̥"},vowelFeatures:{variant:"open"}},{type:"phonetic-vowel",questionObject:{id:10,valuePhonemic:"ı",valuePhonetic:"ɨ",examplePhonemic:"ışık",examplePhonetic:"ɨʃɨk"},vowelFeatures:{variant:"close"}},{type:"phonetic-vowel",questionObject:{id:11,valuePhonemic:"i",valuePhonetic:"i",examplePhonemic:"iğne",examplePhonetic:"i:nɛ"},vowelFeatures:{variant:"close"}},{type:"phonetic-vowel",questionObject:{id:12,valuePhonemic:"i",valuePhonetic:"ɪ",examplePhonemic:"ilgi",examplePhonetic:"ɪlɟɪ"},vowelFeatures:{variant:"open"}},{type:"phonetic-vowel",questionObject:{id:13,valuePhonemic:"u",valuePhonetic:"u",examplePhonemic:"uğur",examplePhonetic:"u:ɣ"},vowelFeatures:{variant:"close"}},{type:"phonetic-vowel",questionObject:{id:14,valuePhonemic:"u",valuePhonetic:"ʊ",examplePhonemic:"lokum",examplePhonetic:"ɫɔkʰʊm"},vowelFeatures:{variant:"open"}},{type:"phonetic-vowel",questionObject:{id:15,valuePhonemic:"ü",valuePhonetic:"y",examplePhonemic:"düğün",examplePhonetic:"dy:n"},vowelFeatures:{variant:"close"}},{type:"phonetic-vowel",questionObject:{id:16,valuePhonemic:"ü",valuePhonetic:"ʏ",examplePhonemic:"ülke",examplePhonetic:"ʏlcʰɛ"},vowelFeatures:{variant:"open"}}]);
            // this.$store.commit('setChallengeQuestionSet', [{type:"phonetic-consonant",questionObject:{id:1,valuePhonemic:"k",valuePhonetic:"k",examplePhonemic:"karton",examplePhonetic:"kʰɑɾtɔn"},consonantFeatures:{variant:"postdorsal"}},{type:"phonetic-consonant",questionObject:{id:2,valuePhonemic:"k",valuePhonetic:"c",examplePhonemic:"kekik",examplePhonetic:"cʰecɪc"},consonantFeatures:{variant:"predorsal"}},{type:"phonetic-consonant",questionObject:{id:3,valuePhonemic:"g",valuePhonetic:"g",examplePhonemic:"gamze",examplePhonetic:"gɑmzɛ"},consonantFeatures:{variant:"postdorsal"}},{type:"phonetic-consonant",questionObject:{id:4,valuePhonemic:"g",valuePhonetic:"ɟ",examplePhonemic:"göz",examplePhonetic:"ɟœz̥"},consonantFeatures:{variant:"predorsal"}},{type:"phonetic-consonant",questionObject:{id:5,valuePhonemic:"v",valuePhonetic:"v",examplePhonemic:"vargı",examplePhonetic:"vɑɾgɨ"},consonantFeatures:{variant:"fricative"}},{type:"phonetic-consonant",questionObject:{id:6,valuePhonemic:"v",valuePhonetic:"ʋ",examplePhonemic:"kovan",examplePhonetic:"kʰɔʋɑn"},consonantFeatures:{variant:"approximant"}},{type:"phonetic-consonant",questionObject:{id:7,valuePhonemic:"z",valuePhonetic:"z",examplePhonemic:"zekâ",examplePhonetic:"zeca:"},consonantFeatures:{variant:"voiced"}},{type:"phonetic-consonant",questionObject:{id:8,valuePhonemic:"z",valuePhonetic:"z̥",examplePhonemic:"tuz",examplePhonetic:"tʰʊz̥"},consonantFeatures:{variant:"devoiced"}},{type:"phonetic-consonant",questionObject:{id:9,valuePhonemic:"h",valuePhonetic:"x",examplePhonemic:"hasat",examplePhonetic:"xɑsɑt"},consonantFeatures:{variant:"postdorsal"}},{type:"phonetic-consonant",questionObject:{id:10,valuePhonemic:"h",valuePhonetic:"ç",examplePhonemic:"hidayet",examplePhonetic:"çɪdɑ:jet"},consonantFeatures:{variant:"predorsal"}},{type:"phonetic-consonant",questionObject:{id:11,valuePhonemic:"m",valuePhonetic:"m",examplePhonemic:"melek",examplePhonetic:"melɛc"},consonantFeatures:{variant:"bilabial"}},{type:"phonetic-consonant",questionObject:{id:12,valuePhonemic:"m",valuePhonetic:"ɱ",examplePhonemic:"enfes",examplePhonetic:"eɱfɛs"},consonantFeatures:{variant:"labiodental"}},{type:"phonetic-consonant",questionObject:{id:13,valuePhonemic:"n",valuePhonetic:"n",examplePhonemic:"nesne",examplePhonetic:"nesnɛ"},consonantFeatures:{variant:"alveolar"}},{type:"phonetic-consonant",questionObject:{id:14,valuePhonemic:"n",valuePhonetic:"ŋ",examplePhonemic:"yenge",examplePhonetic:"jeŋɟɛ"},consonantFeatures:{variant:"postdorsal"}},{type:"phonetic-consonant",questionObject:{id:15,valuePhonemic:"r",valuePhonetic:"r",examplePhonemic:"resim",examplePhonetic:"resɪm"},consonantFeatures:{variant:"trill"}},{type:"phonetic-consonant",questionObject:{id:16,valuePhonemic:"r",valuePhonetic:"ɾ",examplePhonemic:"araba",examplePhonetic:"ɑɾɑbɑ"},consonantFeatures:{variant:"tap-or-flap"}},{type:"phonetic-consonant",questionObject:{id:17,valuePhonemic:"r",valuePhonetic:"ɣ",examplePhonemic:"pınar",examplePhonetic:"pʰɨnɑɣ"},consonantFeatures:{variant:"fricative"}},{type:"phonetic-consonant",questionObject:{id:18,valuePhonemic:"l",valuePhonetic:"ɬ",examplePhonemic:"okul",examplePhonetic:"ɔkʊɬ"},consonantFeatures:{variant:"postdorsal"}},{type:"phonetic-consonant",questionObject:{id:19,valuePhonemic:"l",valuePhonetic:"l",examplePhonemic:"lokma",examplePhonetic:"lɔkmɑ"},consonantFeatures:{variant:"predorsal"}}]);
            
            // Set answer data schema for the first question.
            this.$store.commit('setAnswerDataSchema', this.getAnswerDataSchema(this.curQuestion.type));
        
            // Generate options for the first question.
            let optionGenerator = new OptionGenerator();
            if(this.curQuestion.type === 'phonemic-vowel'){
                this.scorelist = this.getInitialScorelist(this.curQuestion.type);
                this.backnessOptions    = optionGenerator.generateVowelBacknessOptions();
                this.heightOptions      = optionGenerator.generateVowelHeightOptions();
                this.roundednessOptions = optionGenerator.generateVowelRoundednessOptions();
            }
            else if(this.curQuestion.type === 'phonemic-consonant'){
                this.scorelist = this.getInitialScorelist(this.curQuestion.type);
                this.placeOptions  = optionGenerator.generatePlaceOptions(this.curQuestion.consonantFeatures.place);
                this.mannerOptions = optionGenerator.generateMannerOptions(this.curQuestion.consonantFeatures.manner);
            }
            else if(this.curQuestion.type === 'phonetic-vowel'){
                this.scorelist = this.getInitialScorelist(this.curQuestion.type);
                this.variantOptions = optionGenerator.generateVowelVariantOptions();
            }
            else if(this.curQuestion.type === 'phonetic-consonant'){
                this.scorelist = this.getInitialScorelist(this.curQuestion.type);
                this.variantOptions = optionGenerator.generateConsonantVariantOptions(this.curQuestion.consonantFeatures.variant);
            }

            // Reset challenge stats.
            this.$store.commit('resetChallengeStats');
        },

        mounted(){
            // Play first question vocalization after 500ms.
            setTimeout(() => this.vocalize(), 500);

            // Play the animation for the first question.
            this.$nextTick(() => {
                // Play animations.
                document.querySelector(`.question-object-${this.curQuestion.type}`).classList.add('slide-in');
                setTimeout(() => {
                    // @reason: I wrapped classlist removal in try catch because when a user quickly
                    // does skip-check and completes practice session, DOM can't find the question
                    // object element which causes a type error that it cannot read classList prop of null.
                    try{ document.querySelector(`.question-object-${this.curQuestion.type}`).classList.remove('slide-in'); }
                    catch(error){ return; }
                }, 500);
            });
        },
    };
</script>

<style scoped src="@/css/views/view-challenge-practice.css"></style>